// Patches Bootstrap's Modal to be null-safe after dispose().
//
// BaseComponent#dispose() nulls `_element`. If a `transitionend` callback
// scheduled before dispose() still runs `_hideModal`, it crashes:
//
//   this._element.style.display = 'none'
//   TypeError: Cannot read properties of null (reading 'style')
//
// See: TSHMANAGERWEB-HS (Sentry). Same class of Turbo + Bootstrap 5.3.x race
// as bootstrap_tooltip_safety.js.
import { Modal } from "bootstrap"

const originalHideModal = Modal.prototype._hideModal

Modal.prototype._hideModal = function patchedHideModal() {
  if (!this._element) {
    return
  }

  return originalHideModal.call(this)
}

const originalDispose = Modal.prototype.dispose
Modal.prototype.dispose = function patchedModalDispose() {
  try {
    return originalDispose.call(this)
  } catch (error) {
    if (error instanceof TypeError && /null|undefined/.test(String(error.message))) {
      return
    }
    throw error
  }
}
